import i18next from 'i18next'

const isCorrectValue = (param: any): param is string => typeof param === 'string' && !!param
const options = { ns: i18next.language }

function getDoctorDescription({ experience, category, science }: {
  experience?: any
  category?: any
  science?: any
}) {
  let description = ''

  if (isCorrectValue(experience)) {
    description += `${i18next.t('Стаж', options)} ${experience}`
  }

  if (isCorrectValue(category)) {
    const categoryText = category.toLowerCase() === i18next.t('нет', options)
      ? i18next.t('Нет категории', options)
      : `${category} ${i18next.t('категория', options)}`

    description += description
      ? ` • ${categoryText}`
      : categoryText
  }

  if (isCorrectValue(science)) {
    const scienceText = science.toLowerCase() === i18next.t('нет', options)
      ? i18next.t('Нет степени', options)
      : `${science}`

    description += description
      ? `, ${scienceText.toLowerCase()}`
      : scienceText
  }

  return description
}

export default getDoctorDescription
